import { DiscountConfiguration } from '@ca/common/types'
import { OrderParams, OrderPriceSummary } from '../summary/getOrderPriceSummary'
import { bottomUpStrategy } from './bottomUpStrategy'
import { topDownStrategy } from './topDownStrategy'

// Assuming we have 3 levels of discounts from top: order, item and variable
const strategies = {
  topDown: topDownStrategy,
  bottomUp: bottomUpStrategy,
} as const

const applyDiscountStrategy = (
  orderPrice: OrderPriceSummary,
  discounts: DiscountConfiguration[],
  strategy: keyof typeof strategies = 'topDown',
  params: OrderParams
) => {
  return strategies[strategy](orderPrice, discounts, params)
}

export default applyDiscountStrategy
